import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';

type PropsTypes = {
  color?: string;
};

function LogoutIconNew({ color }: PropsTypes) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg data-testid="logout-icon-new" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.0576 17.7832L21.0576 12.7832M21.0576 12.7832L16.0576 7.7832M21.0576 12.7832H9.05762M9.05762 3.7832H7.85762C6.17746 3.7832 5.33738 3.7832 4.69565 4.11018C4.13116 4.3978 3.67222 4.85675 3.3846 5.42123C3.05762 6.06297 3.05762 6.90305 3.05762 8.5832V16.9832C3.05762 18.6634 3.05762 19.5034 3.3846 20.1452C3.67222 20.7097 4.13116 21.1686 4.69565 21.4562C5.33738 21.7832 6.17746 21.7832 7.85762 21.7832H9.05762"
          stroke={color ?? theme.palette.common.black}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
}

export default memo(LogoutIconNew);
